import { LanguageType } from '@app/interfaces/interfaces';

interface CompletionModel {
  id: number;
  name: string;
  value: string;
}

export const completionModel: CompletionModel[] = [
  {
    id: 1,
    name: 'gpt-4',
    value: 'gpt-4',
  },
  {
    id: 2,
    name: 'gpt-4-32k',
    value: 'gpt-4-32k',
  },
  {
    id: 3,
    name: 'gpt-4o-mini',
    value: 'gpt-4o-mini',
  },
  {
    id: 4,
    name: 'gpt-4o',
    value: 'gpt-4o',
  },
  {
    id: 5,
    name: 'aai-vn-xs1',
    value: 'aai-vn-xs1',
  },
  {
    id: 6,
    name: 'gpt-3.5-turbo-0125',
    value: 'gpt-3.5-turbo-0125',
  },
  {
    id: 7,
    name: 'gpt-3.5-turbo-16k',
    value: 'gpt-3.5-turbo-16k',
  },

  {
    id: 8,
    name: 'asko-v2',
    value: 'asko-v2',
  },
];
